[
    {
        "id": 138732,
        "typ": 1,
        "partner": null,
        "civility": 0,
        "typpay": 0,
        "store": 1,
        "firstname": "AIMEE CLAUDE",
        "name": "CELIENTO",
        "roles": [
            3
        ],
        "street1": null,
        "street2": null,
        "street3": null,
        "zip": null,
        "city": null,
        "country": null,
        "email": null,
        "tel1": "04 94 62 52 75",
        "tel2": null,
        "is_default": false,
        "data": [
            {
                "id": "1",
                "value": "Etage 2"
            },
            {
                "id": "2",
                "value": "Code 12*54"
            }
        ],
        "addresses": [
            {
                "id": 138733,
                "typ": 1,
                "partner": 138732,
                "civility": null,
                "typpay": null,
                "store": null,
                "firstname": "AIMEE CLAUDE",
                "name": "CELIENTO",
                "roles": [
                    4
                ],
                "street1": "LA PEROUZE B",
                "street2": "137 BD DE L ESCAILLON",
                "street3": null,
                "zip": "83200",
                "city": "TOULON",
                "country": null,
                "email": null,
                "tel1": "04 94 62 52 75",
                "tel2": null,
                "is_default": true,
                "data": {
                    "cufs": [
                        {
                            "id": "1",
                            "value": "Etage 2"
                        },
                        {
                            "id": "2",
                            "value": "Code 12*54"
                        }
                    ]
                },
                "addresses": null,
                "lnk_orders": null,
                "action": null
            }
        ],
        "lnk_orders": null,
        "action": null
    }
]